import { Support } from "modules/support";

const SupportPage = () => {
  return <Support />;
};

export default SupportPage;
